import { useTranslation } from 'react-i18next';

interface GuestCounterProps {
  label: string;
  count: number;
  onIncrement: () => void;
  onDecrement: () => void;
  minValue?: number;
  maxValue?: number;
}

export default function GuestCounter({ 
  label, 
  count, 
  onIncrement, 
  onDecrement, 
  minValue = 0,
  maxValue = Number.MAX_SAFE_INTEGER
}: GuestCounterProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between py-3">
      <span className="text-base font-medium text-gray-900">{label}</span>
      <div className="flex items-center space-x-3">
        <button
          onClick={() => count > minValue && onDecrement()}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          disabled={count <= minValue}
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
          </svg>
        </button>
        <span className="w-8 text-center text-lg font-semibold text-gray-900">{count}</span>
        <button
          onClick={() => count < maxValue && onIncrement()}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-500 hover:bg-blue-600 disabled:opacity-30 disabled:cursor-not-allowed text-white transition-colors"
          disabled={count >= maxValue}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>
    </div>
  );
}